import React from 'react';
import styles from './ButtonEffects.module.css';

type Props = {
	value: string;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	placeholder: string;
	className?: string;
	onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
	name?: string;
	id?: string;
};

const FilterSearchButton: React.FC<Props> = ({
	value,
	onChange,
	placeholder,
	className = '',
	onKeyDown,
	name = 'search',
	id,
}) => {
	return (
		<div className={`filter-team__btn-find btn-main btn-main-find ${styles.searchButton} ${className}`}>
			<input
				type="text"
				id={id ?? name}
				name={name}
				onChange={onChange}
				onKeyDown={onKeyDown}
				value={value}
				placeholder={placeholder}
				className={`filter-team__btn-find_input ${styles.searchInput}`}
			/>
		</div>
	);
};

export default FilterSearchButton;
